import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/how-it-works", label: "How it works" },
  { to: "/contact", label: "Contact" },
];

const linkCls = ({ isActive }) =>
  [
    "text-sm font-medium",
    isActive ? "text-slate-900" : "text-slate-600 hover:text-slate-900",
  ].join(" ");

export default function EmbeddedNav() {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <div className="flex items-center justify-between gap-4 md:gap-6">
        <Link to="/" className="flex items-center min-w-0" onClick={() => setOpen(false)}>
          <span className="inline-flex h-40 w-80 items-center justify-start md:h-52 md:w-[26rem]">
            <img
              src="/assets/logo.png"
              alt="Zebra MicroWealth"
              className="h-full w-auto object-contain"
            />
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          {links.map((link) => (
            <NavLink key={link.to} to={link.to} className={linkCls}>
              {link.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <button
            type="button"
            className="md:hidden inline-flex items-center justify-center rounded-xl border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700"
            onClick={() => setOpen((prev) => !prev)}
            aria-expanded={open}
            aria-controls="embedded-mobile-nav"
          >
            {open ? "Close" : "Menu"}
          </button>

          <a
            href="https://5577-8888.webfin.co.za/webloans/"
            className="inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold text-white
                       bg-gradient-to-r from-pink-400 to-pink-600
                       shadow-[0_12px_30px_rgba(236,72,153,0.30)]
                       hover:brightness-105 transition"
          >
            <span className="md:hidden">Apply</span>
            <span className="hidden md:inline">Apply Now</span>
          </a>
        </div>
      </div>

      {open ? (
        <div id="embedded-mobile-nav" className="mt-3 rounded-2xl border border-slate-200 bg-white/80 p-4 shadow-sm md:hidden">
          <div className="flex flex-col gap-3">
            {links.map((link) => (
              <NavLink key={link.to} to={link.to} className={linkCls} onClick={() => setOpen(false)}>
                {link.label}
              </NavLink>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
